<template>
    <p class="survey-lead">
        <slot />
    </p>
</template>
<style lang="scss">
@use 'sass:color';
@import '@/variables';

.survey-lead {
    font-size: $font-size-lg;
    font-weight: 500;
    line-height: 1.5rem;
    color: color.adjust($dark-color, $lightness: -20%);
}
</style>
